import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import { Link } from 'react-router-dom';
import Image from '../elements/Image';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const blankLink = { url: '' };
  const [linkState, setLinkState] = useState([
    { ...blankLink },
  ]);

  const addLink = () => {
    setLinkState([...linkState, { ...blankLink }]);
  }

  const removeLink = index => {
    const link = [...linkState];
    link.splice(index, 1);
    setLinkState(link);
  }

  const handleLinkChange = (e) => {
    const updatedLinks = [...linkState];
    updatedLinks[e.target.dataset.idx][e.target.className] = e.target.value;
    setLinkState(updatedLinks);
  };

  const [sentLinksLength, setSentLinksLength] = useState([
    { length: 0 },
  ]);

  const [shortenLinkState, setShortenLinkState] = useState([
    { short_url: '' },
  ]);

  const [loadingState, setLoadingState] = useState(false);

  const [userIpAdd, setUserIpAdd] = useState([
    { ip_add: '' },
  ]);

  fetch('https://api64.ipify.org/?format=json', { 
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    redirect: 'follow',
    referrerPolicy: 'no-referrer'
  })
  .then((response) => response.json())
  .then((ip) => {
    setUserIpAdd([{ ip_add: ip['ip'] }]);
  });
  
  const handleSubmit = (event) => {
    setLoadingState(true);

    // Regex for URL validation
    var data = [];
    let count = 0;
    for (let i = 0; i < linkState.length; i++) {
      let _link = linkState[i]['url'];
      if (_link.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g) !== null) {
        data.push(_link);
        count++;
      } else if (_link.match(/(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g) !== null) {
        data.push(_link);
        count++;
      } else if (_link.match(/[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g) !== null) {
        data.push(_link);
        count++;
      }
    }

    if (count !== linkState.length) {
      alert('Enter a valid URL');
      setLoadingState(false);
      return;
    }
    
    // Duplicate URLs check
    for (let i = 0; i < linkState.length; i++) {
      for (let j = i + 1; j < linkState.length; j++) {
        if (linkState[i]['url'] === linkState[j]['url']) {
          alert('Remove duplicate URLs');
          setLoadingState(false);
          return;
        }
      }
    }
    
    // Check for MergeURL input
    for (let i = 0; i < linkState.length; i++) {
      if (linkState[i]['url'].substring(0, 22) === "https://mergeurl.netlify.app/o" || linkState[i]['url'].substring(0, 22) === "https://mergeurl.netlify.app/v") {
        alert('You provided a MergeURL');
        setLoadingState(false);
        return;
      }
      if (linkState[i]['url'].substring(0, 26) === "https://www.mergeurl.netlify.app/o" || linkState[i]['url'].substring(0, 26) === "https://www.mergeurl.netlify.app/v") {
        alert('You provided a MergeURL');
        setLoadingState(false);
        return;
      }
      if (linkState[i]['url'].substring(0, 21) === "http://mergeurl.netlify.app/o" || linkState[i]['url'].substring(0, 21) === "http://mergeurl.netlify.appv") {
        alert('You provided a MergeURL');
        setLoadingState(false);
        return;
      }
      if (linkState[i]['url'].substring(0, 25) === "http://www.mergeurl.netlify.app/o" || linkState[i]['url'].substring(0, 25) === "http://www.mergeurl.netlify.app/v") {
        alert('You provided a MergeURL');
        setLoadingState(false);
        return;
      }
      if (linkState[i]['url'].substring(0, 14) === "mergeurl.netlify.app/o" || linkState[i]['url'].substring(0, 14) === "mergeurl.netlify.app/v") {
        alert('You provided a MergeURL');
        setLoadingState(false);
        return;
      }
      if (linkState[i]['url'].substring(0, 18) === "www.mergeurl.netlify.app/o" || linkState[i]['url'].substring(0, 18) === "www.mergeurl.netlify.app/v") {
        alert('You provided a MergeURL');
        setLoadingState(false);
        return;
      }
    }

    setSentLinksLength([{ length: linkState.length }]);

    let _linkState = {}
    _linkState['data'] = data;

    fetch('https://mergeurl1.azurewebsites.net/v1/generate/', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'IP-Address': userIpAdd[0]['ip_add']
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      // We convert the React state to JSON and send it as the POST body
      body: JSON.stringify(_linkState)
    })
    .then(response => response.json())
    .then(response => {
      setLoadingState(false);
      if (response === "QUOTA_COMPLETED") {
        alert('Our system triggered a spam warning. You have generated too many MergeURLs today. Contact our support team if you think it is a mistake.');
        return;
      } else {
        setShortenLinkState([{ short_url: response }]);
      }
    });

    event.preventDefault();
  };
  
  const onClickCopy = () => {
    var text1 = document.getElementById("clipboard-text-1");
    text1.innerHTML = "Copied!"

    var text2 = document.getElementById("clipboard-text-2");
    text2.innerHTML = "Copied!"
  }

  const onHoverCopy = () => {
    var text1 = document.getElementById("clipboard-text-1");
    text1.innerHTML = "Copy to clipboard";

    var text2 = document.getElementById("clipboard-text-2");
    text2.innerHTML = "Copy to clipboard";
  }

  var QRCode = require('qrcode.react');

  const downloadQR = () => {
    const canvas = document.getElementById("qr");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "mergeurl-qr.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const outerClasses = classNames(
    'hero section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  alert('This product has been discontinued from August 2022. The current website you are about to visit is a snapshot. Close this pop-up to visit the website.');

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <div className={splitClasses}>
            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <h1 className="mt-0 mb-32" data-reveal-delay="200">
                  Merge and Shorten upto <span className="text-color-primary">5 links</span>
                </h1>
                  <div>
                    <p className="m-0 mb-32" data-reveal-delay="400">
                      Are you sick of posting multiple URLs? Here, you can create a tailored <b>MergeURL</b> hassle-free <b>without any user registration</b>.<br></br>
                    </p>
                    <div className="mt-0">
                      {shortenLinkState[0].short_url !== "" && loadingState === false ? (
                        <div className="mb-32 center-content">
                          <p><b>Here are your links and a QR Code which you can share: </b></p>
                          <p>
                            <b>To open: </b> 
                            <Link to={"/o/" + shortenLinkState[0].short_url} target="_blank" rel="noopener noreferrer">
                              <span className="text-color-primary">https://mergeurl.netlify.app/o/{shortenLinkState[0].short_url}</span>
                            </Link>
                            <div className="copy">
                              <CopyToClipboard text={"https://mergeurl.netlify.app/o/" + shortenLinkState[0].short_url} onCopy={onClickCopy}>
                                <button className="ml-16 copy-download-button" onMouseOut={onHoverCopy}>
                                  <span className="copy-text" id="clipboard-text-1">Copy to clipboard</span>
                                  Copy
                                </button>
                              </CopyToClipboard>
                            </div>
                            <br></br>
                            <b>To view: </b> 
                            <Link to={"/v/" + shortenLinkState[0].short_url} target="_blank" rel="noopener noreferrer">
                              <span className="text-color-primary">https://mergeurl.netlify.app/v/{shortenLinkState[0].short_url}</span>
                            </Link>
                            <div className="copy">
                              <CopyToClipboard text={"https://mergeurl.netlify.app/v/" + shortenLinkState[0].short_url} onCopy={onClickCopy}>
                                <button className="ml-16 copy-download-button" onMouseOut={onHoverCopy}>
                                  <span className="copy-text" id="clipboard-text-2">Copy to clipboard</span>
                                  Copy
                                </button>
                              </CopyToClipboard>
                            </div>
                          </p>
                          {sentLinksLength[0].length > 1 ? (
                            <QRCode 
                              id="qr" 
                              value={"https://mergeurl.netlify.app/v/" + shortenLinkState[0].short_url} 
                              level={"H"} 
                              includeMargin={true}
                              imageSettings={{
                                src: "https://mergeurl.netlify.app/logo192.png",
                                x: null,
                                y: null,
                                height: 24,
                                width: 24,
                                excavate: true,
                              }}
                            />
                          ) : ( 
                            <QRCode 
                              id="qr" 
                              value={"https://mergeurl.netlify.app/o/" + shortenLinkState[0].short_url} 
                              level={"H"} 
                              includeMargin={true}
                              imageSettings={{
                                src: "https://mergeurl.netlify.app/logo192.png",
                                x: null,
                                y: null,
                                height: 24,
                                width: 24,
                                excavate: true,
                              }}
                            />
                          )} 
                          <br></br>
                          <button className="copy-download-button" onClick={downloadQR}>
                            Download QR
                          </button>
                        </div>
                      ) : loadingState ? (
                        <div className="mb-32">
                          <p><b>We're loading your MergeURL. It may take some time.</b></p>
                        </div>
                      ) : (
                        <div className="mb-32">
                          <p><b>Your link will appear here on a successful merge.</b></p>
                        </div>
                      )}
                    </div>
                    <div>
                      <form>
                        {
                          linkState.map((val, idx) => {
                            const linkID = `url-${idx}`;;
                            return (
                              <div key={`url-${idx}`}>
                                <input
                                  type="text"
                                  name={Link}
                                  data-idx={idx}
                                  id={linkID}
                                  className="url"
                                  placeholder="Enter a URL"
                                  value={linkState[idx].url}
                                  onChange={handleLinkChange}
                                  required
                                />
                              </div>
                            );
                          })
                        }
                      </form>
                      <ButtonGroup className="mt-16">
                        {linkState.length < 5 &&
                        <Button className="ml-16" tag="a" color="secondary" wideMobile onClick={addLink}>
                          Add
                        </Button>}
                        {linkState.length !== 1 &&
                        <Button className="ml-16" tag="a" color="dark" wideMobile onClick={() => removeLink(linkState.length - 1)}>
                          Remove
                        </Button>}
                        <Button tag="a" color="primary" wideMobile onClick={handleSubmit}>
                          Merge and Shorten
                        </Button>
                      </ButtonGroup>
                    </div>
                  </div>
                </div>
                <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/feature-split-image-00.png')}
                  alt="Features split 00"
                  style={{ width: 400, height: 400 }} />
                </div>
             </div>
          </div>
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
